import { Component, Input, OnChanges, ChangeDetectorRef, inject } from '@angular/core';
import { Chart, ChartType, ChartDataset} from 'chart.js';
import { NWMBarChartSettings, NWMChartSettings } from './NWMChartSettings';
import { APIService } from 'app/services/api.service';
import { AuthenticationService } from 'app/services/auth.service';
import { LoaderService } from "app/services/loader.service";
import { tooltipType } from "app/components/NWMCharts/NWMCharts.module";
import { AppConfig } from "app/app.config";
import { BaseChartDirective } from 'ng2-charts';

type apiDataType = {
  GraphInformation: {
    Value: number;
    Year: string;
  }[];
};

@Component({
    selector: 'CFRollingChart',
    templateUrl: './nwmchart.component.html',
    styleUrls: ['./nwmchart.component.scss'],
    imports: [BaseChartDirective]
})

export class CFRollingChartComponent implements OnChanges {
  private api = inject(APIService);
  private auth = inject(AuthenticationService);
  private loaderService = inject(LoaderService);
  private config = inject(AppConfig);
  private ref = inject(ChangeDetectorRef);

  @Input() plan?: string;
  @Input() limit?: string;

  public dataLoaded = false;
  public chartData: ChartDataset[] = [{data:[], backgroundColor: '#0b273f'}];
  public chartLabels: string[] = [];
  public chartType: ChartType = 'bar';
  public chartLegend = false;
  public chartPercent?: string[];
  public tooltip: tooltipType = {visible:false, rows:[]};
  public chartSettings: NWMBarChartSettings;
  public width = 500;
  public height = 250;

  constructor() {
    this.chartSettings = new NWMChartSettings();
  }

  ngOnChanges(): void {
    this.dataLoaded = false;
    this.tooltip.visible = false;

    this.chartSettings.options.plugins = {tooltip:{enabled: false, external: (a)=>this.customTooltip(a.chart)}};
    Object.assign(this.chartSettings.options.scales!['x']!.ticks!, {autoSkip: true, maxRotation: 90, minRotation: 90,padding:7});
    this.loadChart();
  }

  customTooltip(chart: Chart): void {
    const tooltipModel = chart.tooltip!;
    this.tooltip.visible = tooltipModel.opacity !== 0;
    if (tooltipModel.body) {
      const i = tooltipModel.dataPoints[0].dataIndex;
      this.tooltip.rows = [
        { key: 'Rolling Quarter:', value: tooltipModel.title[0] },
        { key: 'Cash Flow:', value: this.api.formatCurrency(this.chartData[0].data[i] as number) },
      ];
    }
    setTimeout(()=>{this.ref.detectChanges();});
  }

  loadChart() {
    this.loaderService.display(true, 'CFRolling');
    const reRg = this.auth.getCurrentReRg()!;
    const vd = this.auth.getCurrentValuationDate();
    const planPath = this.api.getPlanPath(this.plan || '', reRg.IsPershing);

    this.api.get<apiDataType>(`${this.config.portfolio.portfolioDetailsCashFlowRollingUrl}/${reRg.ReRgId}/${vd}/${planPath}`).subscribe(
      data => {
        this.dataLoaded = false;
        setTimeout(()=>{this.dataLoaded = true});
        this.chartLabels = [];
        this.chartData[0].data = [];
        this.chartPercent = [];
        if (!data || !data.GraphInformation) return;
        let graphInformation = data.GraphInformation;
        if (this.limit) graphInformation = graphInformation.slice(-this.limit);
        for (let i = 0; i < graphInformation.length; i++) {
          this.chartLabels.push(
            graphInformation[i].Year
          )
          this.chartData[0].data.push(
            graphInformation[i].Value
          )
          this.chartPercent.push(
            '$' + graphInformation[i].Value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          )
        }

        this.chartSettings.options.scales!['y']!.suggestedMax = this.chartSettings.getSuggestedMax(this.chartData[0].data as number[], .2);
        this.chartSettings.options.scales!['y']!.ticks!.callback = (value, index, ticks) =>
          this.chartSettings.getYAxisLabelToShow(ticks.map(t=>t.value), value as number);
        this.loaderService.display(false, 'CFRolling');
      },
      () => {
        this.loaderService.display(false, 'CFRolling');
      }
    );
  }
}
